import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { SectionInterface } from '@campus/dal';

@Component({
  standalone: false,
  selector: 'campus-edu-content-display-section',
  templateUrl: './edu-content-display-section.component.html',
  styleUrls: ['./edu-content-display-section.component.scss'],
})
export class EduContentDisplaySectionComponent implements OnInit {
  @HostBinding('class')
  defaultClasses = ['edu-content-display-section', 'surface', 'block', 'corner-m', 'p-s', 'border'];

  @HostBinding('attr.data-section-theme')
  sectionTheme: string;

  @Input() section: SectionInterface;

  ngOnInit(): void {
    if (this.section?.config?.theme) {
      this.sectionTheme = this.section.config.theme;
    }
  }
}
